import { useTranslation } from "@impero-com/common/utils/i18n";
import { PendoProps, Tooltip } from "@impero-com/ui";
import { Select } from "antd";

import { TimePeriod } from "api/generated/model";

import { CustomRangePicker } from "./CustomRangePicker";
import * as theme from "./TimeFilter.css";
import {
    TIME_PERIOD_KINDS,
    TimePeriodKind,
    localizeTimePeriod,
} from "./timePeriod";

interface TimeFilterProps extends PendoProps {
    value: TimePeriod;
    onChange: (value: TimePeriod) => void;
}

const EMPTY_CUSTOM: TimePeriod = {
    type: "Custom",
    data: { startDate: null, endDate: null },
};

/** The always-present period select shared by the dashboard and Control Health. */
export function TimeFilter({
    value,
    onChange,
    "data-pendo": dataPendo,
}: TimeFilterProps) {
    const { t } = useTranslation();

    const options = TIME_PERIOD_KINDS.map((kind) => ({
        label: localizeTimePeriod(kind, t),
        value: kind,
    }));

    const handleKindChange = (kind: TimePeriodKind) => {
        onChange(kind === "Custom" ? EMPTY_CUSTOM : { type: kind });
    };

    return (
        <div className={theme.container}>
            <Tooltip title={t("Dashboard_TimeFilter_Tooltip")}>
                <Select
                    data-pendo={dataPendo}
                    value={value.type}
                    onChange={handleKindChange}
                    options={options}
                    className={theme.select}
                    popupClassName={theme.popup}
                />
            </Tooltip>
            {value.type === "Custom" && (
                <CustomRangePicker
                    value={value.data}
                    onChange={(data) => onChange({ type: "Custom", data })}
                />
            )}
        </div>
    );
}
